import { useContext, useEffect, useRef, useState } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { AppContext } from '../../../context/App';
import { useInitServiceCountryFromQuery } from '../../../utils';

export function useIdpRedirect() {
  const context = useContext(AppContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const hasAttempted = useRef(false);
  const idpName = searchParams.get('idp');
  const [isDiscovering, setIsDiscovering] = useState(() => !!idpName);
  const navigate = useNavigate();

  useInitServiceCountryFromQuery(idpName ? context : undefined);

  useEffect(() => {
    if (
      !idpName ||
      hasAttempted.current ||
      !context?.authentication?.ssoDiscoverIdP
    ) {
      return;
    }

    hasAttempted.current = true;

    const discover = async () => {
      const codeChallenge =
        await context.authentication.generateAuthChallenge?.();
      const authorizeUrl = await context.authentication.ssoDiscoverIdP?.(
        idpName,
        codeChallenge,
      );

      if (authorizeUrl) {
        const redirectTo = searchParams.get('redirectTo');
        if (redirectTo) {
          sessionStorage.setItem('appRedirectTo', redirectTo);
        }
        window.location.href = authorizeUrl;
        return;
      }

      context?.authentication.codeVerifierStorage.clearCodeVerifier();
      setIsDiscovering(false);
      searchParams.delete('idp');
      setSearchParams(searchParams, { replace: true });
    };

    discover().catch(() => {
      context?.authentication.codeVerifierStorage.clearCodeVerifier();
      navigate('/login?ssoError=true', { replace: true });
    });
  }, [context, idpName, searchParams, setSearchParams, navigate]);

  return { isDiscovering };
}
